export default function makeIconComponent(registry) {
    return {
        props: ['svgIcon', 'title'],
        data() {
            return {
                icon: {
                    viewBox: '',
                    svg: '',
                    classes: []
                }
            };
        },
        render(createElement) {
            const iconClasses = this.icon.classes || [];
            const innerHTML = this.title
                ? `<title>${this.title}</title>${this.icon.svg}`
                : this.icon.svg;
            return createElement('svg', {
                class: ['mom-icon'].concat(iconClasses),
                attrs: {
                    viewBox: this.icon.viewBox
                },
                domProps: { innerHTML }
            });
        },
        created() {
            const icon = registry.get(this.svgIcon);
            if (icon instanceof Promise) {
                icon.then((svg) => this.icon = svg)
                    .catch((e) => window.console.warn(`No entry found for '${this.svgIcon} in registry.`));
            }
            else if (icon) {
                this.icon = icon;
            }
        }
    };
}
//# sourceMappingURL=Icon.js.map